import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { baseurlvmkp } from "../Files/Subjects/Baseurl";

const ExamGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const checkProgress = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));

        const res = await axios.get(
          `${baseurlvmkp}/exam/getexampending/${user.details.id}`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        const {
          relationshipid,
          healthid,
          workeducationid,
          wealthid,
          selfawarenessid,
        } = res.data;

        const mapping = [
          { label: "Relationship", id: relationshipid, path: "/Exam" },
          { label: "Health", id: healthid, path: "/health" },
          { label: "Work Education", id: workeducationid, path: "/we" },
          { label: "Wealth", id: wealthid, path: "/wealth" },
          { label: "Self Awareness", id: selfawarenessid, path: "/Selfawareness" },
        ];

        const firstPending = mapping.find((m) => m.id === 0);

        if (firstPending) {
          // only redirect if user is on wrong page
          if (location.pathname !== firstPending.path) {
            navigate(firstPending.path, { replace: true });
          } else {
            setAllowed(true);
          }
        } else {
          // all tests completed
          setAllowed(true);
        }
      } catch (err) {
        console.log(err);
      }
    };

    checkProgress();
  }, [location.pathname]);

  return allowed ? children : null;
};

export default ExamGuard;